<template>
    <div class="kgk-password-reset">
        <PasswordResetForm :reset-code="$route.params.code" />
    </div>
</template>

<script>
    // @ is an alias to /src
    import PasswordResetForm from '@/components/login/PasswordResetForm.vue';

    export default {
        name: 'PasswordReset',
        components: {
            PasswordResetForm,
        }
    }
</script>
